import { Component, OnInit, Injectable } from '@angular/core';
import { ParamMap, Router, ActivatedRoute,Params } from '@angular/router';
import { Globals } from '../../globals';
//import { HttpErrorResponse, HttpClient,HttpRequest,HttpEventType,HttpResponse } from '@angular/common/http';
//import { Http, ResponseContentType } from '@angular/http';
import { HttpClient, HttpRequest, HttpEvent, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-testing',
  templateUrl: './testing.component.html',
  styleUrls: ['./testing.component.css']
})

@Injectable()
export class TestingComponent implements OnInit {

  fsdgdgfsdfgsdg:any;
  percentDone:any = 0;
  constructor(private router:Router, private route: ActivatedRoute,private global:Globals, private http: HttpClient) { 
    //this.mybookmarkList=[];

  /* this.route.params.subscribe((params: Params) => {
      this.bookmarkType = params['id'];
      this.formoption={createpost:false,bookmarkType:this.bookmarkType}
    });
   */

   

  }

  ngOnInit() {
   
     

     
  }

  getData() {
    this.percentDone = 0;
    let fileName = 'testing.zip';
    var filePath=this.global.tsAnsImageUrl+fileName;

    const req = new HttpRequest('GET', filePath, {
      reportProgress: true,
      responseType: 'blob'
    });

    this.http.request(req).subscribe((event: HttpEvent<any>) => {
      switch (event.type) {
        case HttpEventType.Sent:
          console.log('Request sent!');
          break;
        case HttpEventType.ResponseHeader:
          console.log('Response header received!');
          break;
        case HttpEventType.DownloadProgress:
          this.percentDone = Math.round(100 * event.loaded / event.total);
          console.log( this.percentDone);
          break;
        case HttpEventType.Response:
          console.log('Done!', event);
          let file = event.body;
          console.log(file.size + " bytes file downloaded. File type: ", file.type);                
          // create and download link
          var url = window.URL.createObjectURL(file);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove(); // remove the element */

      }

     
    }, error => {
      if(error.status="404"){
             alert('Something went wrong. Please try to latter.');
      }
    }, () => {
      this.percentDone = 0;
     });

    
  }


  download(){
   /* console.log('dddd');
    var url=this.global.tsAnsImageUrl+'1552898165627-test (4).pdf';
    const req = new HttpRequest('GET', url, {
      reportProgress: true,
    });
    
    this.http.request(req).subscribe(event => {
      // Via this API, you get access to the raw event stream.
      // Look for download progress events.
      if (event.type === HttpEventType.DownloadProgress) {
        // This is an download progress event. Compute and show the % done:
        const percentDone = Math.round(100 * event.loaded / event.total);
        console.log(percentDone);
      } else if (event instanceof HttpResponse) {
        console.log('File is completely downloaded!');
      }
    });*/
  }


  /*downloadAttachment(fileName){
    
    var url=this.global.tsAnsImageUrl+fileName;
    return this.http.get(url,{
      responseType: ResponseContentType.Blob,
    })
    .map(res => {
      return {
        filename: fileName,
        data: res.blob()
      };
    }).subscribe(res => {
        var url = window.URL.createObjectURL(res.data);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = res.filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
      }, error => {
             if(error.status="404"){
                    alert('Something went wrong. Please try to latter.');
             }
      }, () => {
       // console.log('Completed file download.')
      });
  
  }*/


}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/testing/testing.component.ts